<template>
  <div class="contents">
    <div class="login">
      <img class="weixin-icon" src="../../assets/weixin.png" />
      <div class="we-login">
        微信授权登录
      </div>
<!--      <div class="save-btn" style="background: #03d10e;" @click="loginA()">确定</div>-->
      <div class="save-btn" style="background: #03d10e;" @click="toGetWXCode()">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      login:1,
      appid:'',
      wxCode: ''
    }
  },
 created(){
    var that = this
   // 非微信环境直接跳过微信授权，给予临时访问能力
   const ua = navigator.userAgent.toLowerCase();
   const isWechat = ua.match(/micromessenger/i) === 'micromessenger';
   if (!isWechat) {
     const tempToken = 'Bearer temp_token_for_web_' + Date.now();
     this.$store.commit('setToken', tempToken);
     this.$store.commit('setTabbarShow', true);
     this.$store.commit('setUserInfo', {
       id: 'web_user_' + Date.now(),
       nickname: '网页访客',
       avatar: '',
       isWebUser: true
     });
     this.$router.replace('/');
     return;
   }
   this.wxCode = this.getQueryString('code')
   var code = this.getQueryString('code')
   if (code !='') {
     that.getLogin()
     console.log('login', this.login)
   } else {
     console.log('不要登录')
     console.log('login', this.login)
   }
  },
  mounted() {
    // var code = this.getQueryString('code')
    // // console.log('codemounted',code)
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);  //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null)
        context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    toGetWXCode() {
      var that = this
      const ua = navigator.userAgent.toLowerCase();
      const isWechat = ua.match(/micromessenger/i) === 'micromessenger';
      if (!isWechat) {
        // 非微信浏览器不触发微信OAuth
        this.$toast('已在网页环境访问，无需微信授权');
        return;
      }
      let redirectUrl = encodeURIComponent('http://jpzs-zst.itos.cn/#/login')
      let WX_APPID = 'wxe86e357621c76520'
      let oAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      var code = this.getQueryString('code')
      console.log('code3',code)
      if (code != '' || code != null) {
        // that.login = 0;
        // console.log('login5', this.login)
        window.location.href = oAuthUrl

      }
    },
    async getLogin(){ // 授权登录 Login
      var that  = this;
      var data = {
        code: this.wxCode,
        source: 'ZHQQ'
      }
      var res = await that.$Http.login(data)
      if (res.code == 200){
        this.$store.commit("setToken", res.data.token); // 保存token
        that.$store.commit('setTabbarShow',true);
        console.log('登录成功')
        this.$router.replace('/')

      } else{
        console.log('要登录')
        this.$toast(res.message)
        this.$store.commit("setToken", ''); // 清除key
      }

    },

  }
}
</script>

<style scoped>
.weixin-icon{width: 140px;height: 140px; margin: 100px auto 60px;display: block;}
.save-btn{width: 90%;height: 88px;line-height: 88px;text-align: center;font-size: 30px;color: #fff;
  background: #03d10e; margin: 100px auto 0;
  border-radius: 65px;}
</style>
